import React, { Component } from 'react';
import style from './GlobeWrapper.css';
class GlobeWrapper extends Component {
    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();
    }
    componentDidMount() {
        // Disable right click context menu
        const wrapper = this.wrapperRef.current;
        wrapper.oncontextmenu = () => false;
        wrapper.onselectstart = () => false;
        this.props.setCanvasWrapper(wrapper);
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        return React.createElement("div", { className: style.wrapper, ref: this.wrapperRef });
    }
}
export default GlobeWrapper;
